export enum DateRangeScope {
  Global = 'global',
  Reporting = 'reporting',
  Assistant = 'assistant',
  DumpViewer = 'dump-viewer',
}
